import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api, ApiError } from '../lib/api';
import { useAuthStore } from '../app/authStore';
import { Button } from '../components/ui';
import { Notice } from '../components/form';

/** 邮箱验证落地页：URL 上带一次性 token，进页面就提交。 */
export function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const status = useAuthStore((state) => state.status);
  const refresh = useAuthStore((state) => state.refresh);

  const [state, setState] = useState<'loading' | 'ok' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (token === '') {
      setState('error');
      setMessage('链接缺少验证令牌，请从邮件中重新打开。');
      return;
    }
    let cancelled = false;
    api
      .post<{ verified: boolean }>('/api/auth/verify-email', { token })
      .then(() => {
        if (cancelled) return;
        setState('ok');
        // 已登录时刷新会话，让顶部横幅与能力闸门立刻更新。
        if (useAuthStore.getState().status === 'authenticated') void refresh();
      })
      .catch((error: unknown) => {
        if (cancelled) return;
        setState('error');
        setMessage(error instanceof ApiError ? error.message : '验证失败，请稍后重试。');
      });
    return () => {
      cancelled = true;
    };
  }, [token, refresh]);

  return (
    <div className="flex min-h-full items-center justify-center bg-canvas px-4 py-10">
      <div className="w-full max-w-[420px] space-y-4">
        <h1 className="text-[28px] font-semibold text-fg">邮箱验证</h1>

        {state === 'loading' ? (
          <Notice tone="info">正在验证，请稍候…</Notice>
        ) : state === 'ok' ? (
          <Notice tone="ok">邮箱已验证，现在可以下单、邀请成员与生成 API Key。</Notice>
        ) : (
          <Notice tone="danger">{message}</Notice>
        )}

        <div className="flex gap-3">
          {status === 'authenticated' ? (
            <Link to="/" className="flex-1">
              <Button variant="primary" block>
                进入控制台
              </Button>
            </Link>
          ) : (
            <Link to="/login" className="flex-1">
              <Button variant="primary" block>
                去登录
              </Button>
            </Link>
          )}
          <Link to="/login" className="flex-1">
            <Button variant="secondary" block>
              返回登录
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
